import { Injectable } from '@angular/core';
import { BehaviorSubject ,  Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable()
export class LoadingSpinnerService {
  private activeSpinners = 0;
  private subject: BehaviorSubject<boolean>;

  constructor() {
    this.subject = new BehaviorSubject<boolean>(false);
  }

  setLoading(value: boolean) {
    if (value) {
      this.activeSpinners++;
      this.subject.next(value);
    } else {
      if (this.activeSpinners > 0) {
        this.activeSpinners--;
      }
      if (this.activeSpinners === 0) {
        this.subject.next(value);
      }
    }
  }

  getLoading(): Observable<boolean> {
    return this.subject.pipe(
      debounceTime(100)
    );
  }

  getCurrentValue(): boolean {
    return this.subject.value;
  }

}
